function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CE85"
    },
    d: "M21.5,32.5V11c0-1.378,1.121-2.5,2.5-2.5h10c0.862,0,1.643,0.511,1.987,1.303l3.111,7.169 c0.267,0.611,0.401,1.26,0.401,1.928V30c0,1.378-1.121,2.5-2.5,2.5H21.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967A44"
    },
    d: "M34,9c0.664,0,1.264,0.393,1.528,1.001l3.112,7.17C38.879,17.72,39,18.301,39,18.9V30 c0,1.103-0.897,2-2,2H22V11c0-1.103,0.897-2,2-2H34 M34,8H24c-1.657,0-3,1.343-3,3v22h16c1.657,0,3-1.343,3-3V18.9 c0-0.732-0.151-1.456-0.443-2.128l-3.112-7.169C36.022,8.63,35.061,8,34,8L34,8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C8D1DB"
    },
    cx: 31.5,
    cy: 32.5,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66798F"
    },
    d: "M31.5,29c1.93,0,3.5,1.57,3.5,3.5S33.43,36,31.5,36c-1.93,0-3.5-1.57-3.5-3.5S29.57,29,31.5,29  M31.5,28c-2.485,0-4.5,2.015-4.5,4.5s2.015,4.5,4.5,4.5s4.5-2.015,4.5-4.5S33.985,28,31.5,28L31.5,28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#66798F"
    },
    cx: 31.5,
    cy: 32.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 24.5,
    style: {
      fill: "#DCD5F2"
    },
    width: 21,
    height: 8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8B75A1"
    },
    d: "M21,25v7H1v-7H21 M22,24H0v9h22V24L22,24z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 3.5,
    style: {
      fill: "#8BB7F0"
    },
    width: 21,
    height: 21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4E7AB5"
    },
    d: "M21,4v20H1V4H21 M22,3H0v22h22V3L22,3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#C8D1DB"
    },
    cx: 9.5,
    cy: 32.5,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#66798F"
    },
    d: "M9.5,29c1.93,0,3.5,1.57,3.5,3.5S11.43,36,9.5,36S6,34.43,6,32.5S7.57,29,9.5,29 M9.5,28 C7.015,28,5,30.015,5,32.5S7.015,37,9.5,37s4.5-2.015,4.5-4.5S11.985,28,9.5,28L9.5,28z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#66798F"
    },
    cx: 9.5,
    cy: 32.5,
    r: 1.5
  })), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 24,
    style: {
      fill: "#FFFFFF"
    },
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 26,
    style: {
      fill: "#C74343"
    },
    width: 3,
    height: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2E8FF"
    },
    d: "M29,21.5c-0.275,0-0.5-0.224-0.5-0.5v-9c0-0.276,0.225-0.5,0.5-0.5h7.724l2.375,5.472 c0.267,0.611,0.401,1.26,0.401,1.928v2.6H29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967A44"
    },
    d: "M36.396,12l2.245,5.171C38.879,17.72,39,18.301,39,18.9V21H29v-9H36.396 M37.052,11H29 c-0.552,0-1,0.448-1,1v9c0,0.552,0.448,1,1,1h11v-3.1c0-0.732-0.151-1.456-0.443-2.128L37.052,11L37.052,11z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.a38129eb16154d0a81c6107f99f15f03.svg";
export { ForwardRef as ReactComponent };